import { useEffect, useState, useCallback } from 'react'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { useGraphQLDatas } from '../../components/UserContext'
import Moment from 'react-moment'
import moment from 'moment-timezone'
import _ from 'lodash'

//styles
import './Devices.css'

// semantic ui react
import {
  Container,
  Header,
  Card,
  Icon,
  Table,
  Loader,
  Label
} from 'semantic-ui-react'

// graphql
import gql from 'graphql-tag'
import { useSubscription } from '@apollo/react-hooks'

const ONLINE_SUBSCRIPTION = gql`
  subscription DeviceOnline {
    device_online {
      device_id
      online
    }
  }
`

const Devices = props => {
  // import data from context
  let { loading, error, data } = useGraphQLDatas()

  // states
  let [devices, setDevices] = useState()
  let [tags, setTags] = useState([])
  let [selectedTags, setSelectedTags] = useState([])

  const handleTagClick = useCallback(tag => {
    const index = selectedTags.indexOf(tag)
    if (index > -1) {
      selectedTags.splice(index, 1)
    } else {
      selectedTags.push(tag)
    }
    setSelectedTags([...selectedTags])
  }, [ tags, selectedTags ])

  useEffect(() => {
    if (data && !loading && !error) {
      setDevices(data.me.devices || null)
    }
    
    // extract tags
    if (data?.me?.devices) {
      const arr = data.me.devices.filter(device => !!device.meta.tag).map(device => device.meta.tag)
      const uni = Array.from(new Set(arr))
      setTags(uni)
    }
  }, [data])

  const history = useHistory()

  const handleGoToDevice = id => {
    history.push(`/devices/${id}`)
  }

  const goToCreateDevices = () => {
    history.push('/devices/create')
  }

  // subscription device online
  let { loading: subLoading, error: subError, data: subData } = useSubscription(ONLINE_SUBSCRIPTION)
  useEffect(() => {
    if (devices && !subLoading && subData && subData.device_online) {
      let { device_id, online } = subData.device_online
      let updatedDevices = _.cloneDeep(devices)
      updatedDevices = updatedDevices.map(device => {
        if (device.id === device_id) {
          device.online = online
        }
        return device
      })
      setDevices(updatedDevices)
    }
    if (subError) console.log(subError)
  }, [subData])

  return (
    <Container className='Devices'>

      <Header as='a' floated='right' onClick={goToCreateDevices} className='add-devices'>
        <Icon name='plus square outline' />Add devices
      </Header>

      {/* table of not enabled devices */}
      {!loading && devices && devices.filter(device => !device.enabled).length > 0 && (
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='3'>
                <Icon name='computer' />Devices not activated
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>Serial</Table.HeaderCell>
              <Table.HeaderCell>PO number</Table.HeaderCell>
              <Table.HeaderCell>Purchased At</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {devices && devices.filter(device => !device.enabled).map(device => (
              <Table.Row key={device.id}>
                <Table.Cell><Link to={`/devices/${device.id}`}>{device.serial}</Link></Table.Cell>
                <Table.Cell>{device.po_number}</Table.Cell>
                <Table.Cell>{device.purchased_at && moment(device.purchased_at).format('DD MMM YYYY')}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}

      <Header as='h3' floated='left'>
        <Icon name='computer' />
        <Header.Content>
          Devices
          <Header.Subheader>List of active devices:</Header.Subheader>
        </Header.Content>
      </Header>

      {loading && (<Loader active>Loading devices...</Loader>)}

      {/* tags */}
      {tags.length > 0 && (
        <div style={{ clear: 'both', paddingTop: '1rem' }}>
          <Card fluid>
            <Card.Content>
              <Card.Header>Tags</Card.Header>
              <Card.Description>
                {tags.map((tag, index) => (
                  <Label onClick={e => handleTagClick(tag)} key={`tag-${index}`} color={ selectedTags.indexOf(tag) > -1 ? 'blue' : 'grey' }>{tag}</Label>
                ))}
              </Card.Description>
            </Card.Content>
          </Card>
        </div>
      )}

      {/* list of enabled devices */}
      {!loading && (
        <Card.Group centered style={{marginTop: '1rem', clear: 'left'}}>
          {devices && [...devices].sort((a, b) => b.online - a.online).filter(device => {
            if (selectedTags.length > 0) {
              return device.enabled && selectedTags.indexOf(device.meta.tag) > -1
            } else {
              return device.enabled
            }
          }).map(device => (
            <Card
              key={device.id}
              link
              onClick={() => handleGoToDevice(device.id)}
              color={device.online ? 'green' : 'red'}
            >
              <Card.Content>
                <Icon
                  className='card-icon'
                  name='circle'
                  color={device.online ? 'green' : 'red'}
                />
                <Card.Header>{device.name}</Card.Header>
                <Card.Meta>{device.serial}{(device.description && device.description !== '') ? ` - ${device.description}` : ''}</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Card.Description>
                  Activated At:<span>{moment(device.created_at).format('LL')}</span>
                </Card.Description>
              </Card.Content>
              {device.meta && device.meta.os && device.meta.os.name && (
                <Card.Content extra>
                  <Card.Description>
                    {device.meta.os.name}:<span>{device.meta.os.version || ''}</span>
                  </Card.Description>
                </Card.Content>
              )}
              {device.last_connection && (
                <>
                  {/* offline */}
                  {device.last_connection.destroyed_at && (
                    <Card.Content extra>
                      <Card.Description>
                        Last Seen:<span><Moment fromNow>{moment(device.last_connection.destroyed_at).toDate()}</Moment></span>
                      </Card.Description>
                    </Card.Content>
                  )}
                  {/* online */}
                  {!device.last_connection.destroyed_at && device.last_connection.created_at && (
                    <Card.Content extra>
                      <Card.Description>
                        Online Since:<span><Moment fromNow ago>{device.last_connection.created_at}</Moment></span>
                      </Card.Description>
                    </Card.Content>
                  )}
                </>
              )}
              <Card.Content extra>
                <Card.Meta>{device.model}</Card.Meta>
              </Card.Content>
            </Card>
          ))}
        </Card.Group>
      )}
    </Container>
  )
}

export default Devices
